import { REQUEST_METHOD_POST, REQUEST_METHOD_GET } from '@/common/const';
import * as URL from '../url.js';

export default [
    // 跑马灯
    {
        subUrl: URL.MARQUEE_SHOW, // 请求url
        name: 'marqueeShow', // 接口调用名
        // needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST // post/get 请求
    },
    // 榜单
    {
        subUrl: URL.RANK_SHOW, // 请求url
        name: 'activitiesRankingShow', // 接口调用名
        // needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST // post/get 请求
    },
    // 提额
    {
        subUrl: URL.SWEEPS_CREDIT, // 请求url
        name: 'sweepstake', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST // post/get 请求
    },
    // 提额
    {
        subUrl: URL.SWEEPS_CREDITV2, // 请求url
        name: 'sweepstakeV2', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST // post/get 请求
    },
    // 剩余次数
    {
        subUrl: URL.RESIDUE_DEGREE, // 请求url
        name: 'residueDegree', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST // post/get 请求
    },
    // 中奖记录
    {
        subUrl: URL.RECORD_QUERY, // 请求url
        name: 'winningRecordQuery', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST // post/get 请求
    },

    // 判断是否登录
    {
        subUrl: '/api/mktop/userService/checkLogin', // 请求url
        name: 'login', // 接口调用名
        needToken: true, // 未登录是否跳转ac登录或者App登录页
        method: REQUEST_METHOD_POST // post/get 请求
    },
    // 领券
    {
        subUrl: '/api/mktop/loanInviteCommonService/userRegV2',
        name: 'postCoupon',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 微信分享jssdk
    {
        subUrl: '/jssdk/init?url=' + encodeURIComponent(window.location.href),
        name: 'wxshare',
        needToken: true,
        method: REQUEST_METHOD_GET
    },
    // 获取inviteId
    {
        subUrl: '/api/mktop/loanInviteCommonService/queryInviterId',
        name: 'getInviteId',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 获取MetaInfo
    {
        subUrl: '/api/mktop/loanInviteCommonService/getMetaInfo',
        name: 'getMetaInfo',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 获取MetaInfo list
    {
        subUrl: '/api/mktop/loanInviteCommonService/getMetaInfoList',
        name: 'getMetaInfoList',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 获取SourceFrom
    {
        subUrl: '/api/mktop/loanInviteCommonService/getSourceFromV2',
        name: 'postSource',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 获取SourceFrom判断是否可戳额
    {
        subUrl: '/api/mktop/loanInviteCommonService/getSourceFromV2',
        name: 'getSourceFromV2',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    {
        subUrl: '/api/mktop/winningService/firstAmountAwardStatus',
        name: 'getAwardStatus',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 剩余出额/借款抽奖次数接口——需要登录
    {
        subUrl: '/api/mktop/winningService/remainLotteryNum',
        name: 'remainLotteryNum',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 奖品列表接口
    {
        subUrl: '/api/mktop/commonNotLoginService/awardInfoListV2',
        name: 'awardInfoList',
        // needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 奖品列表接口需要登录态
    {
        subUrl: '/api/mktop/winningService/awardInfoListV2',
        name: 'awardInfoList4Login',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 领取奖品
    {
        subUrl: '/api/mktop/winningService/receiveAwardV2',
        name: 'receiveAward',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    //  推送埋点
    {
        subUrl: '/api/invoppush/pushEventService/sendEvent ',
        name: 'sendEventWithLogin',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    //  未登录推送埋点
    {
        subUrl: '/api/invoppush/pushEventNoneService/sendEvent',
        name: 'sendEventWithoutLogin',
        needToken: false,
        method: REQUEST_METHOD_POST
    },
    //  未登录推送埋点
    {
        subUrl: '/api/mktop/newMGMCashActivityNoneService/shareAward',
        name: 'shareAward',
        needToken: false,
        method: REQUEST_METHOD_POST
    },
    // 被邀请人发现金奖励的被邀请页信息接口-不需要登录
    {
        subUrl: '/api/mktop/inviteeCashAwardService/getInviteUserInfo',
        name: 'getInviteUserInfo',
        needToken: false,
        method: REQUEST_METHOD_POST
    },
    // 挽留接口
    {
        subUrl: '/api/mktop/loanInviteCommonService/getMgmDetentionType',
        name: 'getMgmDetentionType',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 小微认证状态
    {
        subUrl: '/api/mktop/bizAuthService/getBizAuth',
        name: 'getBizAuth',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 小微企业认证专用注册登录接口
    {
        subUrl: '/api/mktop/loanInviteCommonService/userRegV3',
        name: 'userRegV3',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 小微企业认证专用注册登录接口
    {
        subUrl: '/api//mktop/bizAuthService/receiveAuthAward',
        name: 'receiveAuthAward',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    // 灰度被邀请页接口
    {
        subUrl: '/api/mktop/commonLoginService/graySwitchRegisterAward',
        name: 'graySwitchRegisterAward',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    {
        subUrl: '/api/mktop/winningService/queryIncrEInfo',
        name: 'queryIncrEInfo',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
    {
        subUrl: '/api/mktop/winningService/receiveAwardV2',
        name: 'receiveAwardV2',
        needToken: true,
        method: REQUEST_METHOD_POST
    },
];
